import apiClient from "../api/apiClient";
import { endPoints } from "../config/endpoints";

export const chatFirebaseService = {
  async getConversationsAsync({ pageSize = 20, cursor } = {}, signal) {
    const response = await apiClient.get(endPoints.chatFirebase.getConversations, {
      params: { pageSize, cursor: cursor || undefined },
      signal,
    });
    return response.data;
  },

  async getMessagesAsync(conversationId, { pageSize = 30, cursor } = {}, signal) {
    const response = await apiClient.get(
      `${endPoints.chatFirebase.getConversations}/${conversationId}/messages`,
      {
        params: { pageSize, cursor: cursor || undefined },
        signal,
      }
    );
    return response.data;
  },
};
